import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { Pencil, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaDemandaEditada = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    
    if (acaoLower.includes('orientacao') || acaoLower.includes('orientação')) {
        return false;
    }
    
    return acaoLower.includes('editou') || acaoLower === 'demanda editada';
};

const getIconDemandaEditada = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: Pencil, color: 'var(--c8041c7)' };
};

export default function CardDemandaEditada({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconDemandaEditada(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const demandaEditadaConfig = {
    tipo: 'demanda_editada',
    detectaTipo: detectaDemandaEditada,
    getIcon: getIconDemandaEditada,
    temExpansao: () => true,
    Component: CardDemandaEditada
};

